<template>
  <div>
    <v-container>
      <v-row justify="space-between">

        <!-- Ventas por área -->
        <v-col cols="5" class="text-center">
          <v-row class="ma-0 fill-height" justify="center" v-if="!loading_area">
            <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
              <h5 class="font-weight-bold color-black">Ventas por área</h5>
            </v-col>
            <v-col cols="12" sm="12" xs="12" md="12" class="pa-10">
              <doughnut-chart :chart-data="sales_areas" :options="{ responsive: true, maintainAspectRatio: true }"></doughnut-chart>
            </v-col>
          </v-row>

          <loader :loading="loading_area"></loader>
        </v-col>

        <!-- <v-col cols="1" class="text-center"><v-row class="ma-0 fill-height" justify="center"></v-row></v-col> -->

        <span class="vertical-divider"></span>

        <!-- <v-col cols="1" class="text-center"><v-row class="ma-0 fill-height" justify="center"></v-row></v-col> -->

        <!-- Ventas por método de pago -->
        <v-col cols="5" class="text-center">
          <v-row class="ma-0 fill-height" justify="center" v-if="!loading_paymethod">
            <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
              <h5 class="font-weight-bold color-black">Ventas por método de pago</h5>
            </v-col>
            <v-col cols="12" sm="12" xs="12" md="12">
              <doughnut-chart :chart-data="sales_payments" :options="{ responsive: true, maintainAspectRatio: true }"></doughnut-chart>
            </v-col>
          </v-row>

          <loader :loading="loading_paymethod"></loader>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DoughnutChart from './charts/DoughnutChart'
import Loader from '@/components/Loader'

export default {
  name: 'charts-clients',
  props: {
    restaurant: {
      type: Object
    },
    dates: {
      type: Array,
      required: true
    },
    period: {
      type: String,
      required: true
    }
  },
  components: { Loader, DoughnutChart },
  data () {
    return {
      sales_areas: {
        labels: ['Barra', 'Cocina'],
        datasets: [
          {
            backgroundColor: [
              '#01D28E',
              '#01BCD2'
            ],
            data: []
          }
        ]
      },
      sales_payments: {
        labels: [],
        datasets: [
          {
            backgroundColor: [
              '#01BCD2',
              '#01D28E',
              '#FD6250',
              '#000'

            ],
            data: []
          }
        ]
      },
      loading_area: false,
      loading_paymethod: false
    }
  },
  methods: {
    /**
     * Método para obtener los datos de la gráfica de ventas por área
     */
    async getSalesArea () {
      let [ fromDate ] = this.dates
      this.loading_area = true
      try {
        const salesByArea = await this.$api.get(`/v1/restaurants/${this.restaurant._id}/reports/sales-by-area`, {
          date: fromDate,
          type: this.period
        })
        const paymentData = salesByArea.reduce((acc, curr) => {
          const total = Number(Number(curr.total).toFixed(2))
          if (!acc[0] && !acc[1]) {
            acc = [[curr.areaName], [total]]
          } else {
            acc[0].push(curr.areaName)
            acc[1].push(total)
          }
          return acc
        }, [])
        const payload = {
          labels: paymentData[0] || [],
          datasets: [
            {
              backgroundColor: [
                '#01BCD2',
                '#01D28E',
                '#FD6250',
                '#000'

              ],
              data: paymentData[1] || []
            }
          ]
        }
        this.sales_areas = payload
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loading_area = false
    },
    /**
     * Método para obtener los datos de la gráfica de ventas por método de pago
     */
    async getSalesPaymethod () {
      let [ fromDate ] = this.dates
      this.loading_paymethod = true
      try {
        const salesByPayment = await this.$api.get(`/v1/restaurants/${this.restaurant._id}/reports/sales-by-payment`, {
          date: fromDate,
          type: this.period
        })
        const paymentData = salesByPayment.reduce((acc, curr) => {
          const total = Number(Number(curr.total).toFixed(2))
          if (!acc[0] && !acc[1]) {
            acc = [[curr.paymentMethod], [total]]
          } else {
            acc[0].push(curr.paymentMethod)
            acc[1].push(total)
          }
          return acc
        }, [])
        const payload = {
          labels: paymentData[0] || [],
          datasets: [
            {
              backgroundColor: [
                '#01BCD2',
                '#01D28E',
                '#FD6250',
                '#000'

              ],
              data: paymentData[1] || []
            }
          ]
        }
        this.sales_payments = payload
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loading_paymethod = false
    }
  },
  async mounted () {
    await this.getSalesArea()
    await this.getSalesPaymethod()
  },
  watch: {
    dates: function () {
      this.getSalesArea()
      this.getSalesPaymethod()
    },
    period: function () {
      this.getSalesArea()
      this.getSalesPaymethod()
    }
  }
}
</script>
